import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import $ from "jquery";
import userIconForm from "./../img/user-icon-form.svg";
import eyeIconForm from "./../img/eye-icon-form.svg";
import eyeSlashIconForm from "./../img/eye-slash-icon-form.svg";
import { request } from "./../../../config";
import { translate } from 'react-i18next';

class LoginWithUsrAndPwdJuridical extends Component {
    state = {
        feedbackMessage: null,
        username: "",
        password: "",
        blockTimer: 0,
        blockMessage: null
    }
    componentWillUnmount() {
        if (this._blockInterval) clearInterval(this._blockInterval);
    }

    formatBlockTime = (seconds) => {
        if (seconds >= 60) {
            const m = Math.floor(seconds / 60);
            const s = seconds % 60;
            return `${m}:${s < 10 ? '0' + s : s}`;
        }
        return `${seconds}s`;
    }

    startBlockTimer = (seconds, message) => {
        if (this._blockInterval) clearInterval(this._blockInterval);
        this._blockAlertOpen = true;
        this.setState({ blockTimer: seconds, blockMessage: message });
        this.props.alertState(true, "error", this.props.t("error"), `${message} (${this.formatBlockTime(seconds)})`, undefined, undefined, () => { this._blockAlertOpen = false; });
        this._blockInterval = setInterval(() => {
            this.setState(prev => {
                const next = prev.blockTimer - 1;
                if (next <= 0) {
                    clearInterval(this._blockInterval);
                    if (this._blockAlertOpen) this.props.alertState(false, "", "", "");
                    return { blockTimer: 0, blockMessage: null };
                }
                if (this._blockAlertOpen) {
                    this.props.alertState(true, "error", this.props.t("error"), `${prev.blockMessage} (${this.formatBlockTime(next)})`, undefined, undefined, () => { this._blockAlertOpen = false; });
                }
                return { blockTimer: next };
            });
        }, 1000);
    }

    setPasswordVisibility = (event) => {
        if ($(event.target).hasClass("header-sign-section-container-form-group-box-icon-img__password-slash")) {
            $(event.target).removeClass("header-sign-section-container-form-group-box-icon-img__password-slash");
            $(event.target).addClass("header-sign-section-container-form-group-box-icon-img__password");
            $(event.target).attr("src", eyeIconForm);
            $(event.currentTarget).find(".header-sign-section-container-form-group-box-input").attr("type", "password");
        }
        else {
            if ($(event.target).hasClass("header-sign-section-container-form-group-box-icon-img__password")) {
                $(event.target).removeClass("header-sign-section-container-form-group-box-icon-img__password");
                $(event.target).addClass("header-sign-section-container-form-group-box-icon-img__password-slash");
                $(event.target).attr("src", eyeSlashIconForm);
                $(event.currentTarget).find(".header-sign-section-container-form-group-box-input").attr("type", "text");
            }
        }
    }
    loginWithUsrAndPwdJuridicalMethod = (event) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        event.preventDefault();
        let loginWithUsrAndPwdJuridicalRequestBody = {
            username: this.username.value,
            password: this.password.value
        };
        fetch(request("register/loginWithUsrAndPwdJuridicalV3", loginWithUsrAndPwdJuridicalRequestBody))
            .then(res => res.text())
            .then((loginWithUsrAndPwdJuridicalResponseJSON) => {
                const JSON = require('true-json-bigint');
                let loginWithUsrAndPwdJuridicalResponse = JSON.parse(loginWithUsrAndPwdJuridicalResponseJSON);
                if (loginWithUsrAndPwdJuridicalResponse.status.statusCode !== 1) {
                    // if (loginWithUsrAndPwdJuridicalResponse.status.statusCode === 119) {
                    //     this.props.history.push('/login/juridical/mobile/unblock-user/1', {});
                    // }
                    // else {
                    //     this.props.alertState(
                    //         true,
                    //         "error",
                    //         this.props.t("error"),
                    //         this.props.t(loginWithUsrAndPwdJuridicalResponse.status.statusCode)
                    //     );
                    //     this.props.updateAppState('isLoadingTransparentBackground', false);
                    // }
                    const baseMsg = this.props.t(loginWithUsrAndPwdJuridicalResponse.status.statusCode);
                    const remaining = loginWithUsrAndPwdJuridicalResponse.remainingBlockSeconds;
                    if (remaining) {
                        this.startBlockTimer(remaining, baseMsg);
                    } else {
                        this.props.alertState(true, "error", this.props.t("error"), baseMsg);
                    }
                    this.props.updateAppState('isLoadingTransparentBackground', false);

                }
                else if (loginWithUsrAndPwdJuridicalResponse.customer.otpVisible) {
                    // console.log(loginWithUsrAndPwdJuridicalResponse)

                    // console.log(getOtpFromAsanResponse)

                    // localStorage.setItem('userId', loginWithUsrAndPwdJuridicalRequestBody.userId);
                    // localStorage.setItem('verificationCode', loginWithUsrAndPwdJuridicalResponse.verificationCode);
                    // localStorage.setItem('phoneNumber', loginWithUsrAndPwdJuridicalRequestBody.phoneNumber);

                    // console.log("success")
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.props.history.push('/login/juridical/mobile/otp', { loginWithUsrAndPwdJuridicalRequestBody, loginWithUsrAndPwdJuridicalResponse });
                }
                else {
                    // =========ID=========
                    let custId = "";
                    if (typeof (loginWithUsrAndPwdJuridicalResponse.customer.custId) === "object" && loginWithUsrAndPwdJuridicalResponse.customer.custId.hasOwnProperty('c')) {
                        loginWithUsrAndPwdJuridicalResponse.customer.custId.c.forEach(part => {
                            custId += part;
                        });
                    }
                    else {
                        custId += loginWithUsrAndPwdJuridicalResponse.customer.custId;
                    }
                    // =========COMPID=========
                    let compId = "";
                    if (typeof (loginWithUsrAndPwdJuridicalResponse.company.id) === "object" && loginWithUsrAndPwdJuridicalResponse.company.id.hasOwnProperty('c')) {
                        loginWithUsrAndPwdJuridicalResponse.company.id.c.forEach(part => {
                            compId += part;
                        });
                    }
                    else {
                        compId += loginWithUsrAndPwdJuridicalResponse.company.id;
                    }
                    // =========FULLNAME=========
                    // let fullname = loginWithUsrAndPwdJuridicalResponse.customer.name[0].toUpperCase() + loginWithUsrAndPwdJuridicalResponse.customer.name.substring(1, loginWithUsrAndPwdJuridicalResponse.customer.name.length).toLowerCase() +
                    //     ' ' + loginWithUsrAndPwdJuridicalResponse.customer.surname[0].toUpperCase() + loginWithUsrAndPwdJuridicalResponse.customer.surname.substring(1, loginWithUsrAndPwdJuridicalResponse.customer.surname.length).toLowerCase() +
                    //     ' ' + loginWithUsrAndPwdJuridicalResponse.customer.patronymic[0].toUpperCase() + loginWithUsrAndPwdJuridicalResponse.customer.patronymic.substring(1, loginWithUsrAndPwdJuridicalResponse.customer.patronymic.length).toLowerCase();
                    let fullname = loginWithUsrAndPwdJuridicalResponse.customer.surname + ' ' + loginWithUsrAndPwdJuridicalResponse.customer.name + ' ' + loginWithUsrAndPwdJuridicalResponse.customer.patronymic;
                    localStorage.setItem("custId", custId);
                    localStorage.setItem("compId", compId);
                    localStorage.setItem("token", loginWithUsrAndPwdJuridicalResponse.customer.token);
                    localStorage.setItem("secretWord", loginWithUsrAndPwdJuridicalResponse.customer.secretWord);
                    localStorage.setItem("bankCustomerType", loginWithUsrAndPwdJuridicalResponse.customer.bankCustomerType);
                    localStorage.setItem("fullname", fullname);
                    localStorage.setItem("custObject", JSON.stringify(loginWithUsrAndPwdJuridicalResponse));
                    localStorage.setItem("isOperNo", loginWithUsrAndPwdJuridicalResponse.company.isOperNo);
                    this.props.updateAppState('isAuthed', true);
                    localStorage.setItem("compIdEncrypt", loginWithUsrAndPwdJuridicalResponse.company.compIdEncrypt);
                    localStorage.setItem("compName", loginWithUsrAndPwdJuridicalResponse.company.name);
                    localStorage.setItem("custTypeId", loginWithUsrAndPwdJuridicalResponse.customer.custTypeId);
                    localStorage.setItem("phoneNumber", loginWithUsrAndPwdJuridicalResponse.customer.mobile);

                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                }
            );
    }

    forgotPassword = () => {
        this.props.history.push('/login/juridical/mobile/forgot-password/1');
    }

    componentDidMount() {
        let intervalUsername = setInterval(() => {
            if (this.username && this.username.value) {
                this.setState({ username: this.username.value });
                clearInterval(intervalUsername);
            }
        }, 100);
        let intervalPassword = setInterval(() => {
            if (this.password && this.password.value) {
                this.setState({ password: this.password.value });
                clearInterval(intervalPassword);
            }
        }, 100);
        this.props.updateIsAsan(false);
        this.props.updateIsJuridical(true);
    }

    render() {
        let { feedbackMessage, username, password } = this.state;
        let { t } = this.props;
        return (
            <form className="header-sign-section-container-form">
                <div className="header-sign-section-container-form-group">
                    <label className="header-sign-section-container-form-group-label">{t('username')}</label>
                    <div className="header-sign-section-container-form-group-box">
                        <input type="text" className="header-sign-section-container-form-group-box-input" placeholder={t('username')} ref={(input) => { this.username = input }} value={username} onChange={(event) => { this.setState({ feedbackMessage: null, username: event.target.value }) }} />
                        <div className="header-sign-section-container-form-group-box-icon">
                            <img src={userIconForm} className="header-sign-section-container-form-group-box-icon-img  header-sign-section-container-form-group-box-icon-img__user" alt="User icon" />
                        </div>
                    </div>
                </div>
                <div className="header-sign-section-container-form-group" onClick={this.setPasswordVisibility}>
                    <label className="header-sign-section-container-form-group-label">{t('password')}</label>
                    <div className="header-sign-section-container-form-group-box">
                        <input type="password" className="header-sign-section-container-form-group-box-input" placeholder={t('password')} ref={(input) => { this.password = input }} value={password} onChange={(event) => { this.setState({ feedbackMessage: null, password: event.target.value }) }} />
                        <div className="header-sign-section-container-form-group-box-icon">
                            <img src={eyeIconForm} className="header-sign-section-container-form-group-box-icon-img header-sign-section-container-form-group-box-icon-img__password" alt="User password" />
                        </div>
                    </div>
                </div>
                <div className="header-sign-section-container-form-validation-feedback">
                    {
                        feedbackMessage ? <p className="header-sign-section-container-form-validation-feedback-message">{feedbackMessage}</p> : null
                    }
                </div>
                <div className="header-sign-section-container-form-additional">
                    <div className="header-sign-section-container-form-additional-remember">
                        <label className="header-sign-section-container-form-additional-remember-label">{t('remember password')}
                            <input type="checkbox" className="header-sign-section-container-form-additional-remember-checkbox" />
                            <span className="header-sign-section-container-form-additional-remember-checkmark"></span>
                        </label>
                    </div>
                    <button type="button" className="header-sign-section-container-form-additional-forget-password" onClick={this.forgotPassword}>{t('forget password')}</button>
                </div>
                <button className="header-sign-section-container-form-button" disabled={
                    username.trim() === "" || password.trim() === ""
                } onClick={this.loginWithUsrAndPwdJuridicalMethod}>{t('login')}</button>
            </form>
        )
    }
}


export default translate("translation")(LoginWithUsrAndPwdJuridical);